import { create } from "zustand";

import { LocaleStorageKeys } from "@/constants";

type UsersTableState = {
    showShiftDecision: boolean;
    showStartShiftConfirmation: boolean;
    showStartFreeDayConfirmation: boolean;
    showCompleteShiftConfirmation: boolean;
    showFloatingActionButton: boolean;
};

type UsersTableActions = {
    actions: {
        updateShiftDecision: (val?: boolean) => void;
        updateShowStartShiftConfirmation: (val?: boolean) => void;
        updateShowStartFreeDayConfirmation: (val?: boolean) => void;
        updateShowCompleteShiftConfirmation: (val?: boolean) => void;
        updateShowFloatingActionButton: (val?: boolean | undefined) => void;
    };
};
export const useUsersTableStore = create<UsersTableState & UsersTableActions>()((set) => ({
    showShiftDecision: false,
    showStartShiftConfirmation: false,
    showStartFreeDayConfirmation: false,
    showCompleteShiftConfirmation: false,
    showFloatingActionButton: !!JSON.parse(
        window.localStorage.getItem(LocaleStorageKeys?.SHIFT_FLOATING_ACTION_BUTTON) || "true"
    ),
    actions: {
        updateShiftDecision: (val) => set({ showShiftDecision: val ?? false }),
        updateShowStartShiftConfirmation: (val) => set({ showStartShiftConfirmation: val ?? false }),
        updateShowStartFreeDayConfirmation: (val) => set({ showStartFreeDayConfirmation: val ?? false }),
        updateShowCompleteShiftConfirmation: (val) => set({ showCompleteShiftConfirmation: val ?? false }),
        updateShowFloatingActionButton: (val) => {
            window.localStorage.setItem(LocaleStorageKeys?.SHIFT_FLOATING_ACTION_BUTTON, JSON.stringify(val));
            set({ showFloatingActionButton: val ?? false });
        },
    },
}));

export const useShiftShowShiftDecision = () => useUsersTableStore((state) => state.showShiftDecision);
export const useShiftShowStartShiftConfirmation = () => useUsersTableStore((state) => state.showStartShiftConfirmation);
export const useShiftShowFloatingActionButton = () => useUsersTableStore((state) => state.showFloatingActionButton);
export const useShiftShowCompleteShiftConfirmation = () =>
    useUsersTableStore((state) => state.showCompleteShiftConfirmation);
export const useShiftShowStartFreeDayConfirmation = () =>
    useUsersTableStore((state) => state.showStartFreeDayConfirmation);

export const useShiftActions = () => useUsersTableStore((state) => state.actions);
